<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

const _handleError = () => clearError({ redirect: '/' })

const { t } = useI18n()

const sitedata: any = useSiteData()

useHead({
  title: props?.error?.message || t('page_not_found'),
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: sitedata.value?.favicon ? sitedata.value?.favicon : null,
    },
  ],
})
</script>

<template>
  <NuxtLayout :name="sitedata?.layout || 'default'">
    <EmptyPage :error="props?.error" />
  </NuxtLayout>
</template>
